import { all_information, loadingShow } from '../App';
import { EditOperations } from '../services/Operations/OperationServices';

const divided = (duration: number, size: number) => {
  var remamining = duration;
  var packages = [];
  while (remamining > 0) {
    var thisPacket = Math.min(remamining, size);
    packages.push(thisPacket);
    remamining -= thisPacket;
  }
  return packages;
};

export const generateSegmentation = (
  theCurrentEl: any,
  workingHour: number,
  allowSeg: boolean
) => {
  if (!allowSeg) {
    return;
  }
  let theDayNumber = Math.ceil(theCurrentEl.Duration / Number(workingHour));
  let theInitialDate = new Date(theCurrentEl.StartDate);
  let theDurationPerDay = divided(theCurrentEl.Duration, workingHour);
  theCurrentEl.taskData.Segments = [];
  for (let i = 0; i < theDayNumber; i++) {
    let workingMSPerDay = Number(theDurationPerDay[i]) * 60 * 60 * 1000;
    let theStartDate = theInitialDate;
    let theEndDate = new Date(theStartDate.getTime() + workingMSPerDay);
    theStartDate.setDate(theStartDate.getDate() + 1);
    theCurrentEl?.taskData?.Segments?.push({
      StartDate: new Date(theStartDate),
      Duration: theDurationPerDay[i],
      TaskID: theCurrentEl.TaskID,
    });
  }
};
export const arrayPreparing = (
  gantArray: Array<any>,
  theBatchArray: Array<any>,
  allowSeg: boolean,
  dayWorkingTime: Array<any>,
  ShiftElementData: Array<any>
) => {
  gantArray?.map((res: any, index: number) => {
    if (res.level === 1 && index === gantArray.length - 1) {
      const first_obj: any = {
        ...preaparingTaskSide(
          res,
          allowSeg,
          dayWorkingTime,
          ShiftElementData
        ),
      };
      delete first_obj.materialStatus;
      EditOperations(first_obj)
        .then(() => {
          loadingShow(false);
        })
        .catch((err: any) => {});
      return;
    }
    if (res.level === 0) {
      var theObject = {
        scheduled_end_date: res.EndDate,
        scheduled_start_date: res.StartDate,
        order_id: res.TaskID,
        created_by: all_information.user_id,
        percentage: res.Progress,
        isDone: res.isDone,
        isKanban: false,
        isRejected: res.isRejected,
        reason: res.reason,
        subtasks: [
          ...res.childRecords.map((el: any) => {
            return preaparingTaskSide(
              el,
              allowSeg,
              dayWorkingTime,
              ShiftElementData
            );
          }),
        ],
      };
      theBatchArray.push(theObject);
    }
  });
};

const preaparingTaskSide = (
  el: any,
  allowSeg: boolean,
  dayWorkingTime: Array<any>,
  ShiftElementData: Array<any>
) => {
  let theOrgDesc = el.TaskName.replace(el.operationSequence + ' - ', '');
  var req =
    el.required === '' || el.required === undefined || el.required === null || el.required === '0'
      ? 1
      : Number(el.required);
  // if (el.Work === 0) el.Work = el.Duration;
  var duration = el.Work /req;
  if (allowSeg) {
    if (!el.shift) {
      let workingHour = Number(dayWorkingTime[0].to - dayWorkingTime[0].from);
      generateSegmentation(el, workingHour, allowSeg);
    } else {
      let theShift = ShiftElementData.filter((elShift) => {
        return (
          elShift.rosterCode === el.shift && elShift.rosterType === 'Shift'
        );
      });
      let workingHour = theShift[0].duration.split(':')[0];
      let workingMin = theShift[0].duration.split(':')[1];
      if (Number(workingHour) === 23 && Number(workingMin) === 59) {
        workingHour = 24;
      }
      generateSegmentation(el, workingHour, allowSeg);
    }
  }
  el.Duration=( (isNaN(duration) || !isFinite(duration)) ? 0 : duration);
  return {
    scheduled_end_date: el.EndDate,
    scheduled_start_date: el.StartDate,
    operationId: el.TaskID,
    createdBy: all_information.user_id,
    percentage: el.Progress?.toString(),
    duration:( (isNaN(duration) || !isFinite(duration)) ? 0 : duration).toString(),
    dependencyCode:
      el.Predecessor?.toString() !== null ? el.Predecessor?.toString() : '',
    estHours: el.Work.toString(),
    required: req.toString(),
    tradeCode: el.tradeCode,
    teamCode: el.teamCode,
    shift: el.shift,
    tradeId: el.tradeId,
    longDescription: theOrgDesc,
    operationDescription: theOrgDesc,
    Segments: el?.taskData?.Segments
      ? [
          ...el?.taskData?.Segments?.map((seg: any) => {
            return {
              StartDate: seg.StartDate,
              Duration: seg.Duration,
              operationId: el.TaskID,
            };
          }),
        ]
      : [],

    Resources: el?.taskData?.Resources
      ? [
          ...el?.taskData?.Resources?.map((resource: any) => {
            return {
              resourceName: resource.resourceName,
              resourceId: resource.resourceId,
              operationId: el.TaskID,
            };
          }),
        ]
      : [],
  };
};
